(() => {
  'use strict';
  const configNode = document.getElementById('xbloom-config');
  if (!configNode || window.xbloomCommerceReady) return;
  window.xbloomCommerceReady = true;
  const { routes, labels, locale, currency } = JSON.parse(configNode.textContent);
  const panel = document.getElementById('xb-cart-panel');
  const toggle = document.querySelector('.xb-cart-toggle');
  const backdrop = document.querySelector('.xb-cart-backdrop');
  // Webflow animates the header with transforms; mount the dialog outside that containing block.
  const portal = document.createElement('div');
  portal.className = 'xb-cart xb-cart-portal';
  portal.append(backdrop, panel);
  document.body.append(portal);
  const status = panel.querySelector('.xb-cart-status');
  const checkout = panel.querySelector('[data-checkout]');
  const products = [...document.querySelectorAll('.xb-product')];
  let busy = false;
  let cart = null;
  let previousFocus;
  let formatter = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'code' });
  const money = cents => formatter.format(cents / 100);
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function updateProduct(form) {
    const option = form.elements.id.selectedOptions[0];
    const button = form.querySelector('[data-add]');
    const available = option?.dataset.available === 'true';
    button.disabled = busy || !available;
    const label = button.querySelector('[data-add-label]') || button;
    label.textContent = available ? labels.add : labels.sold_out;
    if (!option) return;
    form.querySelector('[data-price]').textContent = option.dataset.price;
    const compare = form.querySelector('[data-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = !option.dataset.compare;
    const image = form.querySelector('[data-product-image]');
    if (image && option.dataset.image) image.src = option.dataset.image;
  }
  function setBusy(value) {
    busy = value;
    panel.setAttribute('aria-busy', String(value));
    panel.querySelectorAll('[data-line-key]').forEach(control => { control.disabled = value; });
    products.forEach(updateProduct);
    checkout.disabled = value || !cart?.item_count;
  }
  async function request(url, body) {
    const response = await fetch(url, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : labels.error);
    return data;
  }
  function renderCart(data) {
    cart = data;
    formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: data.currency || currency, currencyDisplay: 'code' });
    document.querySelector('[data-cart-count]').textContent = data.item_count;
    panel.querySelector('[data-cart-total]').textContent = money(data.total_price);
    const listing = panel.querySelector('.xb-cart-items');
    listing.replaceChildren();
    if (!data.items.length) listing.append(element('p', '', labels.empty));
    data.items.forEach(item => {
      const row = element('div', 'xb-cart-item');
      const image = element('img');
      image.alt = item.product_title;
      image.loading = 'lazy';
      if (item.image) { image.src = item.image; row.append(image); }
      const detail = element('div', 'xb-cart-detail');
      detail.append(element('div', 'xb-cart-title', item.product_title));
      if (item.variant_title) detail.append(element('div', 'xb-cart-variant', item.variant_title));
      if (item.selling_plan_allocation) detail.append(element('div', '', item.selling_plan_allocation.selling_plan.name));
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (value && !key.startsWith('_')) detail.append(element('div', '', `${key}: ${value}`));
      });
      const price = element('div', 'xb-cart-price', money(item.final_line_price));
      if (item.original_line_price > item.final_line_price) price.append(element('s', '', money(item.original_line_price)));
      detail.append(price);
      const controls = element('div', 'xb-cart-controls');
      const label = element('label', '', labels.quantity);
      const input = element('input');
      input.type = 'number'; input.min = '0'; input.step = '1'; input.value = item.quantity;
      input.dataset.lineKey = item.key; input.setAttribute('aria-label', `${labels.quantity}: ${item.product_title}`);
      label.append(input);
      const remove = element('button', 'link', labels.remove);
      remove.type = 'button'; remove.dataset.lineKey = item.key; remove.dataset.remove = 'true';
      remove.setAttribute('aria-label', `${labels.remove}: ${item.product_title}`);
      controls.append(label, remove); detail.append(controls); row.append(detail); listing.append(row);
    });
    setBusy(busy);
  }
  function openCart() {
    if (!panel.hidden) return;
    previousFocus = document.activeElement;
    panel.hidden = false; backdrop.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('xb-cart-open');
    panel.querySelector('[data-cart-close]').focus();
  }
  function closeCart() {
    panel.hidden = true; backdrop.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('xb-cart-open');
    previousFocus?.focus();
  }
  async function refresh() {
    if (busy) return;
    setBusy(true); status.textContent = '';
    try { renderCart(await request(`${routes.cart}.js`)); }
    catch (error) { cart = null; status.textContent = labels.error; }
    finally { setBusy(false); }
  }
  toggle.addEventListener('click', () => { if (panel.hidden) { openCart(); refresh(); } else closeCart(); });
  panel.querySelector('[data-cart-close]').addEventListener('click', closeCart);
  backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', event => {
    if (panel.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeCart(); }
    if (event.key === 'Tab') {
      const focusable = [...panel.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href]')];
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  });
  products.forEach(form => {
    form.elements.id.addEventListener('change', () => { updateProduct(form); form.querySelector('[role=status]').textContent = ''; });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || form.querySelector('[data-add]').disabled) return;
      const message = form.querySelector('[role=status]');
      const id = form.elements.id.value;
      setBusy(true); message.textContent = labels.adding;
      let added = false;
      try {
        await request(routes.add, { items: [{ id, quantity: 1 }] });
        added = true;
        renderCart(await request(`${routes.cart}.js`));
        message.textContent = labels.added; status.textContent = labels.added; openCart();
      } catch (error) {
        // An add may succeed even if the following refresh fails. Never automatically retry a mutation.
        message.textContent = added ? `${labels.added} ${labels.error}` : error.message || labels.error;
        if (added) { cart = null; status.textContent = message.textContent; openCart(); }
      } finally { setBusy(false); }
    });
    updateProduct(form);
  });
  async function changeLine(key, quantity) {
    if (busy) return;
    if (!Number.isSafeInteger(quantity) || quantity < 0) { renderCart(cart); return; }
    setBusy(true); status.textContent = '';
    try { renderCart(await request(routes.change, { id: key, quantity })); status.textContent = labels.updated; }
    catch (error) {
      status.textContent = error.message || labels.error;
      try { renderCart(await request(`${routes.cart}.js`)); } catch (_) { cart = null; }
    } finally { setBusy(false); }
  }
  panel.addEventListener('change', event => {
    if (event.target.matches('input[data-line-key]')) changeLine(event.target.dataset.lineKey, event.target.value === '' ? NaN : Number(event.target.value));
  });
  panel.addEventListener('click', event => {
    const button = event.target.closest('[data-remove]');
    if (button) changeLine(button.dataset.lineKey, 0);
  });
  panel.querySelector('.xb-checkout-form').addEventListener('submit', event => {
    if (busy || !cart?.item_count) event.preventDefault();
    // Native POST /{locale}/cart with name=checkout preserves Shopify's cart and checkout flow.
  });
  // Agent integration (2026-10-08). Tools reuse the same Ajax cart, busy guard and dialog as the buttons.
  // Checkout and payment are intentionally not exposed: the shopper must press checkout themselves.
  const MAX_AGENT_QUANTITY = 10;
  const pageUrl = document.querySelector('link[rel="canonical"]')?.href || location.href;
  function catalog() {
    return products.map(form => ({
      product_id: Number(form.dataset.productId),
      title: form.querySelector('.xb-product-title')?.textContent.trim(),
      variants: [...form.elements.id.options].map(option => ({
        variant_id: Number(option.value),
        title: option.dataset.title,
        price: option.dataset.price,
        compare_at_price: option.dataset.compare || null,
        available: option.dataset.available === 'true'
      }))
    }));
  }
  function structuredData() {
    for (const node of document.querySelectorAll('script[type="application/ld+json"]')) {
      try {
        const graph = JSON.parse(node.textContent)['@graph'];
        if (Array.isArray(graph)) return graph;
      } catch (_) { /* Ignore third-party or malformed blocks. */ }
    }
    return [];
  }
  function cartSummary() {
    if (!cart) return { error: labels.error };
    return {
      item_count: cart.item_count,
      total: money(cart.total_price),
      items: cart.items.map(item => ({
        line_key: item.key, title: item.product_title, variant: item.variant_title || null,
        quantity: item.quantity, line_total: money(item.final_line_price)
      })),
      checkout: 'Open the cart for the shopper; they must review and press checkout themselves.'
    };
  }
  async function addVariant(id, quantity) {
    if (busy) throw new Error('The cart is busy. Try again shortly.');
    setBusy(true); status.textContent = '';
    try { await request(routes.add, { items: [{ id, quantity }] }); }
    finally { setBusy(false); }
    // The add has succeeded; never retry it. A failed refresh only affects the displayed summary.
    await refresh();
    status.textContent = labels.added;
    openCart();
  }
  const reply = data => ({ content: [{ type: 'text', text: JSON.stringify(data) }] });
  const tools = [
    {
      name: 'xbloom_list_products',
      title: 'List xBloom products',
      description: 'List the xBloom products sold on this page with every variant, its variant_id, current price, compare-at price and availability.',
      inputSchema: { type: 'object', properties: {} },
      annotations: { readOnlyHint: true },
      execute: async () => reply({ page: pageUrl, currency: cart?.currency || currency, products: catalog() })
    },
    {
      name: 'xbloom_get_studio_details',
      title: 'Get xBloom Studio details',
      description: 'Get the xBloom Studio description, specifications, included accessories and current offers in the page language.',
      inputSchema: { type: 'object', properties: {} },
      annotations: { readOnlyHint: true },
      execute: async () => {
        const product = structuredData().find(node => node['@type'] === 'Product') || {};
        return reply({
          name: product.name, description: product.description, award: product.award,
          specifications: (product.additionalProperty || []).map(({ name, value }) => ({ name, value })),
          offers: (product.offers || []).map(({ name, price, priceCurrency, availability }) => ({ name, price, currency: priceCurrency, availability: String(availability).split('/').pop() }))
        });
      }
    },
    {
      name: 'xbloom_get_faq',
      title: 'Get xBloom FAQ',
      description: 'Get the frequently asked questions and answers about xBloom Studio shown on this page.',
      inputSchema: { type: 'object', properties: {} },
      annotations: { readOnlyHint: true },
      execute: async () => {
        const faq = structuredData().find(node => node['@type'] === 'FAQPage');
        return reply((faq?.mainEntity || []).map(question => ({ question: question.name, answer: question.acceptedAnswer?.text })));
      }
    },
    {
      name: 'xbloom_add_to_cart',
      title: 'Add an xBloom product to the cart',
      description: 'Add a variant listed by xbloom_list_products to the shopper\'s cart and show the cart. Only use after the shopper has chosen the product and variant. Does not check out or pay.',
      inputSchema: {
        type: 'object',
        properties: {
          variant_id: { type: 'integer', description: 'variant_id from xbloom_list_products' },
          quantity: { type: 'integer', minimum: 1, maximum: MAX_AGENT_QUANTITY, default: 1 }
        },
        required: ['variant_id']
      },
      execute: async ({ variant_id: id, quantity = 1 } = {}) => {
        const variant = catalog().flatMap(product => product.variants.map(item => ({ ...item, product: product.title }))).find(item => item.variant_id === id);
        if (!variant) return reply({ error: 'Unknown variant_id. Call xbloom_list_products first.' });
        if (!variant.available) return reply({ error: `${variant.product} (${variant.title}) is sold out.` });
        if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > MAX_AGENT_QUANTITY) return reply({ error: `quantity must be 1-${MAX_AGENT_QUANTITY}.` });
        try { await addVariant(id, quantity); }
        catch (error) { return reply({ error: error.message || labels.error }); }
        return reply({ added: { product: variant.product, variant: variant.title, quantity }, cart: cartSummary() });
      }
    },
    {
      name: 'xbloom_view_cart',
      title: 'View the cart',
      description: 'Return the shopper\'s current cart. Set open to true to show the cart panel so the shopper can review it and check out themselves.',
      inputSchema: { type: 'object', properties: { open: { type: 'boolean', default: false } } },
      annotations: { readOnlyHint: true },
      execute: async ({ open = false } = {}) => {
        await refresh();
        if (open) openCart();
        return reply(cartSummary());
      }
    },
    {
      name: 'xbloom_update_cart_item',
      title: 'Change a cart item quantity',
      description: 'Change the quantity of a cart line from xbloom_view_cart. Quantity 0 removes the line.',
      inputSchema: {
        type: 'object',
        properties: {
          line_key: { type: 'string', description: 'line_key from xbloom_view_cart' },
          quantity: { type: 'integer', minimum: 0, maximum: MAX_AGENT_QUANTITY }
        },
        required: ['line_key', 'quantity']
      },
      execute: async ({ line_key: key, quantity } = {}) => {
        if (!cart?.items.some(item => item.key === key)) return reply({ error: 'Unknown line_key. Call xbloom_view_cart first.' });
        if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > MAX_AGENT_QUANTITY) return reply({ error: `quantity must be 0-${MAX_AGENT_QUANTITY}.` });
        if (busy) return reply({ error: 'The cart is busy. Try again shortly.' });
        await changeLine(key, quantity);
        return reply({ status: status.textContent, cart: cartSummary() });
      }
    }
  ];
  // WebMCP: the W3C draft exposes document.modelContext; earlier Chrome builds used navigator.modelContext.
  const modelContext = document.modelContext || navigator.modelContext;
  if (typeof modelContext?.registerTool === 'function') {
    tools.forEach(tool => {
      try { Promise.resolve(modelContext.registerTool(tool)).catch(error => console.warn('[xBloom] WebMCP', tool.name, error)); }
      catch (error) { console.warn('[xBloom] WebMCP', tool.name, error); }
    });
  }
  // Shopify standard actions otherwise navigate to /cart or reload, leaving this landing page.
  function configureShopifyActions() {
    const actions = window.Shopify?.actions;
    if (!actions) return;
    actions.openCart?.configure?.({ handler: () => { openCart(); refresh(); } });
    actions.updateCart?.configure?.({ handler: async perform => { const result = await perform(); await refresh(); return result; } });
  }
  configureShopifyActions();
  document.addEventListener('DOMContentLoaded', configureShopifyActions, { once: true });
  window.addEventListener('pageshow', () => refresh());
  refresh();
})();
